import { graphql, useStaticQuery } from 'gatsby';

export default () => {
  const { allContentfulNavigationBar } = useStaticQuery(
    graphql`
      query commonMenuBar {
        allContentfulNavigationBar(
          filter: { type: { eq: "islandPetroNavigationBar" } }
        ) {
          edges {
            node {
              title
              type
              imageWithPath {
                id
                path
                title
                type
                image {
                  file {
                    url
                    details {
                      image {
                        width
                        height
                      }
                    }
                  }
                  title
                }
              }
              navigations {
                type
                title
                headerWithText {
                  headerText
                  text {
                    text
                  }
                  title
                  type
                }
                entryWithPath {
                  id
                  path
                  text
                  type
                }
                textWithPath {
                  id
                  path
                  text
                  type
                }
                subNavigations {
                  ... on ContentfulSubNavigation {
                    id
                    type
                    textWithPath {
                      path
                      text
                      type
                    }
                    subMenusWithPaths {
                      ... on ContentfulTextWithPath {
                        id
                        path
                        text
                        type
                      }
                      ... on ContentfulSubNavigation {
                        id
                        type
                        textWithPath {
                          path
                          text
                          type
                        }
                        subMenusWithPaths{
                          ... on ContentfulTextWithPath {
                         id
                         path
                         text
                         type
                       }
                         }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `
  );
  return allContentfulNavigationBar.edges[0].node;
};
